import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import LeftMenu from './LeftMenu';
import { useLayout } from '../contexts/LayoutContext';
import { useAuth } from '../contexts/AuthContext';
import '../styles/components/Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { headerProps, updateHeaderProps } = useLayout();
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();
  const prevAuthState = useRef(isAuthenticated);

  // Clear header props when user logs out (only when auth state actually changes)
  useEffect(() => {
    if (prevAuthState.current && !isAuthenticated) {
      // User just logged out
      updateHeaderProps({
        pageTitle: '',
        interactionExId: '',
        showPageTitle: true,
        showInteractionExId: true,
      });
    }
    prevAuthState.current = isAuthenticated;
  }, [isAuthenticated]);

  // Create user avatar from first and last name initials
  const userAvatar = isAuthenticated && user && user.first_name && user.last_name 
    ? `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase()
    : isAuthenticated && user && user.username 
    ? user.username.charAt(0).toUpperCase() 
    : '';

  const userName = isAuthenticated && user 
    ? `${user.first_name} ${user.last_name}` 
    : '';

  const userEmail = isAuthenticated && user ? user.email : '';

  // Check if we're on the landing page or public live-demo surfaces
  const isLandingPage = location.pathname === '/';
  const isPublicDemo = location.pathname === '/live-demo' || location.pathname.startsWith('/live-demo/');
  const useMinimalChrome = isLandingPage || isPublicDemo;

  return (
    <div className="layout-container">
      {!useMinimalChrome && <LeftMenu />}
      <div className={`main-content-container ${useMinimalChrome ? 'landing-page-layout' : ''}`}>
        {!useMinimalChrome && (
          <Header 
            {...headerProps}
            userName={userName}
            userEmail={userEmail}
            userAvatar={userAvatar}
            // showUserInfo={isAuthenticated}
            showUserAvatar={isAuthenticated}
          />
        )}
        <main className="main-content">
          {children}
        </main>
        {!useMinimalChrome && <Footer />}
      </div>
    </div>
  );
};

export default Layout;